import { app } from "./app";

export const paths = {
  app,
};
